import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyFallbackRoute: InvariantJiraRoute = {
	name: 'legacy-fallback',
	path: '/:any',
};
